import Auth from "./api/Auth.api"
import Cms from "./api/Cms.api"
import Order from "./api/Order.api"
import Driver from "./api/Driver.api"
import Delivery from "./api/Delivery.api"
import Product from "./api/Product.api"
import Shop from "./api/Shop.api"
import Report from "./api/Report.api"
import User from "./api/User.api"
import Enterprise from "./api/Enterprise.api"
import CommerceOrder from "./api/commerce/Order.api"
import CommerceStore from "./api/commerce/Store.api"
import CommerceProduct from "./api/commerce/Product.api"

export default {
    Auth,
    Cms,
    Order,
    Driver,
    Delivery,
    Product,
    Shop,
    Report,
    User,
    Enterprise,
    CommerceOrder,
    CommerceStore,
    CommerceProduct
}